/** A reminder, never evidence of account ownership or a payment permission. */
export function needsBookingPhoneVerification({
  isGuest,
  guestEmailConfirmed,
  bookingPhoneVerified,
  linkedAccountPhoneVerified,
}: {
  isGuest: boolean;
  guestEmailConfirmed?: boolean;
  bookingPhoneVerified?: boolean | null;
  linkedAccountPhoneVerified?: boolean | null;
}): boolean {
  if (isGuest && guestEmailConfirmed !== true) return false;
  if (bookingPhoneVerified !== false) return false;
  if (linkedAccountPhoneVerified !== undefined) return linkedAccountPhoneVerified === false;
  return !isGuest;
}
